import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref, computed, ComputedRef } from "vue";
import { UsuarioDTO } from "@/interfaces/Usuario";
import TablaUsuarios from "@/components/Usuarios/TablaUsuarios.vue";
import MapaUsuarios from "@/components/Mapa/MapaUsuarios.vue";
import { useUsuariosStore } from "@/store/usuarios";


export default /*#__PURE__*/_defineComponent({
  __name: 'JugadoresView',
  setup(__props) {

const usuariosStore = useUsuariosStore();

const users: ComputedRef<UsuarioDTO[]> = computed(() => usuariosStore.usuarios);
const tab = ref("one");

onMounted(async () => {
  // const data = await getUsuariosFast();
  // users.value = data.data;
  if (!users.value.length) {
    await usuariosStore.requestUsuarios();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        color: "primary",
        grow: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "one" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { icon: "mdi-account-group" })
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "two" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { icon: "mdi-map" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
      }, {
        default: _withCtx(() => [
          (tab.value === 'one')
            ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                key: 0,
                value: "one"
              }, {
                default: _withCtx(() => [
                  (users.value.length)
                    ? (_openBlock(), _createBlock(TablaUsuarios, {
                        key: 0,
                        usuarios: users.value
                      }, null, 8, ["usuarios"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (tab.value === 'two')
            ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                key: 1,
                value: "two"
              }, {
                default: _withCtx(() => [
                  (users.value.length)
                    ? (_openBlock(), _createBlock(MapaUsuarios, {
                        key: 0,
                        usersView: users.value
                      }, null, 8, ["usersView"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})